import React, { ReactNode } from "react";
import { useHistory } from "react-router";
import { Container, Grid } from "@material-ui/core";
import { SectionTitle } from "Components/CommonComponents";
import "./FeaturedProducts.css";
import Item from "./Item";

const FeaturedProducts = ({
  list = [],
  header = "",
  align = "left",
}): ReactNode => {
  const navigate = useHistory();
  const navigateToPage =
    (type = "", link) =>
    () => {
      if (type.toLowerCase() === "internal") {
        navigate.push(link);
        return;
      }
      window.location.href = link;
    };
  return (
    <Container>
      <SectionTitle
        header={header}
        fontColor="primary"
        transformText={false}
        align={align}
      />
      <br />
      <Grid container spacing={3} className="featured-products">
        {list.map((item, idx) => (
          <Item {...item} idx={idx} navigateToPage={navigateToPage} />
        ))}
      </Grid>
      <br />
    </Container>
  );
};

export default FeaturedProducts;
